<template>
  <div class="email-received-settings mt-3">
    <h6 class="section-title">{{ $t('nodeSettings') }}</h6>

    <b-form-group
      :label="resolveLabel(accountDef.label, 'Email Account')"
      label-for="esetting-account_id"
      label-size="sm"
      :description="resolveLabel(accountDef.description, '')"
    >
      <v-select
        id="esetting-account_id"
        v-model="localSettings.account_id"
        :options="accountOptions"
        label="label"
        :reduce="option => option.value"
        :loading="loadingAccounts"
        :placeholder="$t('selectEmailAccount')"
        :clearable="true"
        @input="emit"
      />
    </b-form-group>

    <b-form-group
      v-for="setting in otherSettings"
      :key="setting.name"
      :label="resolveLabel(setting.label, setting.name)"
      :label-for="'esetting-' + setting.name"
      label-size="sm"
      :description="resolveLabel(setting.description, '')"
    >
      <b-form-input
        :id="'esetting-' + setting.name"
        v-model="localSettings[setting.name]"
        :placeholder="setting.default"
        @input="emit"
      />
    </b-form-group>
  </div>
</template>

<script>
import VSelect from 'vue-select'

export default {
  name: 'EmailReceivedSettings',
  components: {
    VSelect
  },
  props: {
    value: {
      type: Object,
      default: function () { return {} }
    },
    settingsDef: {
      type: Array,
      default: function () { return [] }
    }
  },
  data: function () {
    return {
      localSettings: {},
      accounts: [],
      loadingAccounts: false
    }
  },
  computed: {
    accountDef: function () {
      var def = this.settingsDef.find(function (s) { return s.name === 'account_id' })
      return def || { label: 'Email Account', description: '' }
    },
    otherSettings: function () {
      return this.settingsDef.filter(function (s) { return s.name !== 'account_id' })
    },
    accountOptions: function () {
      return this.accounts.map(function (acc) {
        return {
          label: acc.email + (acc.name ? ' (' + acc.name + ')' : ''),
          value: acc.id
        }
      })
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val) {
        this.localSettings = Object.assign({}, val || {})
      }
    }
  },
  mounted: function () {
    this.loadAccounts()
  },
  methods: {
    loadAccounts: function () {
      var self = this
      self.loadingAccounts = true
      self.$integrationApi.get('/inbox/accounts').then(function (res) {
        self.accounts = res.data || []
      }).catch(function () {
        self.accounts = []
      }).finally(function () {
        self.loadingAccounts = false
      })
    },
    resolveLabel: function (labelObj, fallback) {
      if (!labelObj) return fallback || ''
      if (typeof labelObj === 'string') return labelObj
      if (typeof labelObj === 'object' && labelObj.locales) {
        var locale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : 'en_US'
        var translated = labelObj.locales[locale]
        if (!translated && locale !== 'en_US') {
          translated = labelObj.locales['en_US']
        }
        if (!translated) {
          var keys = Object.keys(labelObj.locales)
          if (keys.length > 0) translated = labelObj.locales[keys[0]]
        }
        return translated || fallback || ''
      }
      return fallback || ''
    },
    emit: function () {
      this.$emit('input', Object.assign({}, this.localSettings))
    }
  }
}
</script>

<style scoped>
.section-title {
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
